import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { OVERVIEWS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/overviews/")({
  component: () => <DeptContentList cfg={OVERVIEWS} />,
});
